export const qrAndPay = [
    {
        name: 'orders',
        state: 'Orders',
        icon: 'cart-shopping',
        acl: 'order.display',
    },
    {
        type: 'group',
        name: 'products',
        icon: 'shelves',
        acl: 'article.master',
        tabs: [

            {
                name: 'products',
                state: 'Articles',
            },
            {
                name: 'categories',
                state: 'ArticleCategories',
            },
            {
                name: 'parameters',
                state: 'Parameters',
            }
        ],
    },
    {
        name: 'employees',
        state: 'Employees',
        acl: 'employee.display',
        icon: 'users',
    },
    {
        name: 'payments',
        state: 'AccountingPayments',
        icon: 'money-bill',
        acl: 'payment_report.master',
    },
    {
        name: 'tip',
        state: 'EmployeeTips',
        icon: 'coins',
    },
    {
        name: 'tips',
        state: 'AdminTips',
        icon: 'coin',
        acl: 'payment_report.master',
    },
    {
        name: 'settings',
        state: 'SystemSettingsDevicesEShop',
        icon: 'cogs',
        acl: 'system_options.display',
    },
]
